import { useQuery } from '@apollo/client'
import queries from '../../../graphql/queries'
import {
    GetDisasters_Minimal,
    GetDisasters_MinimalVariables,
    GetDisasters_Minimal_disasters,
} from '../../../graphql/queries/typings/GetDisasters_Minimal'
import { EnumDisasterThrough } from '../../../graphql/typings/global_types'
import { useErrorService } from '../errors/ErrorService'
import ErrorHelper, { QueryError } from '../errors/ErrorHelper'

type DisastersState = {
    error?: QueryError
    disastersLoading: boolean
    disasters: GetDisasters_Minimal_disasters[] | null
}

type GetDisasterProps = {
    customerId?: string
    enterpriseId?: string
    // categories?: EnumGuaranteeCategory[]
}

const useGetDisasters = ({ customerId, enterpriseId }: GetDisasterProps): DisastersState => {
    const { errorAlert } = useErrorService()

    const variables: GetDisasters_MinimalVariables = enterpriseId
        ? {
              customerId,
              enterpriseId,
              through: EnumDisasterThrough.through_damage,
          }
        : {
              customerId,
              through: EnumDisasterThrough.through_contract,
          }

    const queryResult = useQuery<GetDisasters_Minimal, GetDisasters_MinimalVariables>(queries.GetDisasters_Minimal, {
        variables,
    })

    const errorMessage = 'Erreur lors de la récupération des sinistres'
    const error = ErrorHelper.getQueryError(queryResult, errorMessage)
    if (queryResult.error) {
        errorAlert(errorMessage, queryResult)
    }

    const queryLoading = queryResult.loading
    const responseData = queryResult.data

    if (!queryLoading) {
        const disasters = responseData && responseData.disasters ? responseData.disasters : null

        return {
            error,
            disasters,
            disastersLoading: false,
        }
    } else {
        return {
            error,
            disasters: null,
            disastersLoading: true,
        }
    }
}

export default useGetDisasters
